import * as moment from 'moment';

export class ExchangeRateModel {
  id: number;
  date: any;

  usdAsk: number;
  usdBid: number;
  usdEURbid: number;
  usdEURask: number;
  usdGBPbid: number;
  usdGBPask: number;
  usdCHFbid: number;
  usdCHFask: number;

  eurAsk: number;
  eurBid: number;
  eurUSDask: number;
  eurUSDbid: number;
  eurGBPask: number;
  eurGBPbid: number;
  eurCHFbid: number;
  eurCHFask: number;

  gbpAsk: number;
  gbpBid: number;
  gbpUSDask: number;
  gbpUSDbid: number;
  gbpEURbid: number;
  gbpEURask: number;
  gbpCHFbid: number;
  gbpCHFask: number;

  chfAsk: number;
  chfBid: number;
  chfUSDask: number;
  chfUSDbid: number;
  chfEURbid: number;
  chfEURask: number;
  chfGBPbid: number;
  chfGBPask: number;


  setFromApiModel(apiModel: any): this {
    this.id = apiModel.id;
    this.date = apiModel.created_at ? moment(apiModel.created_at) : null;

    this.usdAsk = apiModel.usd_to_uah_ask?.toFixed(4) || null;
    this.usdBid = apiModel.usd_to_uah_bid?.toFixed(4) || null;
    this.usdEURbid = apiModel.usd_to_eur_bid?.toFixed(4) || null;
    this.usdEURask = apiModel.usd_to_eur_ask?.toFixed(4) || null;
    this.usdGBPbid = apiModel.usd_to_gbp_bid?.toFixed(4) || null;
    this.usdGBPask = apiModel.usd_to_gbp_ask?.toFixed(4) || null;
    this.usdCHFask = apiModel.usd_to_chf_ask?.toFixed(4) || null;
    this.usdCHFbid = apiModel.usd_to_chf_bid?.toFixed(4) || null;

    this.eurAsk = apiModel.eur_to_uah_ask?.toFixed(4) || null;
    this.eurBid = apiModel.eur_to_uah_bid?.toFixed(4) || null;
    this.eurUSDask = apiModel.eur_to_usd_ask?.toFixed(4) || null;
    this.eurUSDbid = apiModel.eur_to_usd_bid?.toFixed(4) || null;
    this.eurGBPask = apiModel.eur_to_gbp_ask?.toFixed(4) || null;
    this.eurGBPbid = apiModel.eur_to_gbp_bid?.toFixed(4) || null;
    this.eurCHFask = apiModel.eur_to_chf_ask?.toFixed(4) || null;
    this.eurCHFbid = apiModel.eur_to_chf_bid?.toFixed(4) || null;

    this.gbpAsk = apiModel.gbp_to_uah_ask?.toFixed(4) || null;
    this.gbpBid = apiModel.gbp_to_uah_bid?.toFixed(4) || null;
    this.gbpUSDask = apiModel.gbp_to_usd_ask?.toFixed(4) || null;
    this.gbpUSDbid = apiModel.gbp_to_usd_bid?.toFixed(4) || null;
    this.gbpEURbid = apiModel.gbp_to_eur_bid?.toFixed(4) || null;
    this.gbpEURask = apiModel.gbp_to_eur_ask?.toFixed(4) || null;
    this.gbpCHFbid = apiModel.gbp_to_chf_bid?.toFixed(4) || null;
    this.gbpCHFask = apiModel.gbp_to_chf_ask?.toFixed(4) || null;

    this.chfAsk = apiModel.chf_to_uah_ask?.toFixed(4) || null;
    this.chfBid = apiModel.chf_to_uah_bid?.toFixed(4) || null;
    this.chfUSDask = apiModel.chf_to_usd_ask?.toFixed(4) || null;
    this.chfUSDbid = apiModel.chf_to_usd_bid?.toFixed(4) || null;
    this.chfEURbid = apiModel.chf_to_eur_bid?.toFixed(4) || null;
    this.chfEURask = apiModel.chf_to_eur_ask?.toFixed(4) || null;
    this.chfGBPbid = apiModel.chf_to_gbp_bid?.toFixed(4) || null;
    this.chfGBPask = apiModel.chf_to_gbp_ask?.toFixed(4) || null;

    return this;
  }

  setToApi(data: any) {
    return {
      uah_to_usd: (1 / data.usd_to_uah).toFixed(4),
      uah_to_eur: (1 / data.eur_to_uah).toFixed(4),
      uah_to_gbp: (1 / data.gbp_to_uah).toFixed(4),
      uah_to_chf: (1 / data.chf_to_uah).toFixed(4),
      usd_to_uah: data.usd_to_uah,
      usd_to_eur: data.usd_to_eur,
      usd_to_gbp: data.usd_to_gbp,
      usd_to_chf: data.usd_to_chf,
      eur_to_uah: data.eur_to_uah,
      eur_to_usd: data.eur_to_usd,
      eur_to_gbp: data.eur_to_gbp,
      eur_to_chf: data.eur_to_chf ,
      gbp_to_uah: data.gbp_to_uah,
      gbp_to_usd: data.gbp_to_usd,
      gbp_to_eur: data.gbp_to_eur,
      gbp_to_chf: data.gbp_to_chf,
      chf_to_uah: data.chf_to_uah,
      chf_to_usd: data.chf_to_usd,
      chf_to_eur: data.chf_to_eur,
      chf_to_gbp: data.chf_to_gbp
    };
  }
}

